import { useRouter } from 'next/router';
import React, { useState, useEffect, useImperativeHandle } from 'react';
import Link from 'next/link';

function Sort ({ sectionCode, categoryCode, sortCode, sorts, currentCode, onChange, pageChange }) {
  const router = useRouter();
  const [current, setCurrent] = useState(currentCode || (Array.isArray(sorts) && sorts.length > 0 ? sorts[0].code : ''));

  const selectItem = (item, index) => {
    if (typeof onChange === 'function') {
      onChange(item.code);
    }
    setCurrent(item.code);
  };

  return (
    <div className='sorting_btn_w'>
      {sorts.map(({ link, text, code }, index) => {
        const linkQuery = { ...router.query };
        linkQuery.sort = link;

        return (
          <Link
            href={{ pathname: router.pathname, query: linkQuery }}
            key={`sort_category_item_${index}`}
          >
            <a
              className={`sorting_btn_cont ${(current === code) && 'current'}`}
              role='link'
              onClick={() => selectItem({ link, text, code }, index)}
              onKeyUp={(event) => {
                if (event.keyCode === 13) {
                  console.log('onKeyUp occured!!');
                  selectItem({ link, text, code }, index);
                }
              }}
            >
              <span className='sorting_btn_text '>{text}</span>
            </a>
          </Link>
          // </span>
        );
      })}
    </div>
  );
}

export default Sort;
